// extracted by mini-css-extract-plugin
export default {"container":"AnonymousSwitcher_container__N6tTl","tooltip":"AnonymousSwitcher_tooltip__5hRUp"};